import { RequestModelInterface } from "@/service/models/request-model-interface";
import { XmlDocumentWrapper } from "@/utilities/xml-helpers/xml-document-wrapper";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { DrugSampleConcentration } from "./drug-sample-concentration";

export class DrugSample implements RequestModelInterface
{
    public concentrations: DrugSampleConcentration[] = [];

    public constructor(
        public id: string,
        public date: Date,
    )
    {
    }

    public getXml(doc: XmlDocumentWrapper): XmlElementWrapper
    {
        const element = doc.createElement("sample");

        element.appendNewElement("sampleId", this.id);
        element.appendNewElement("sampleDate", this.date.toISOString());

        const concentrationsElement = element.appendNewElement("concentrations");

        concentrationsElement.appendChildren(this.concentrations);

        return element;
    }
}
